<template>
    <div class="feedback">
        <div class="feedback__header">
            <h3 class="feedback__title r-title">{{ name }}</h3>
            <template v-if="flag || error">
                <template v-if="user && access === 'patient'">
                    <!--<span v-if="hasAppointment" class="feedback__header-text">Пожалуйста, оставьте свой отзыв после посещения врача.
                        <br>Нам очень важно Ваше мнение!</span>&ndash;&gt;-->
                    <span class="feedback__header-text">Пожалуйста, оставьте свой отзыв. Нам важно знать Ваше мнение!</span>
                </template>
                <template v-else-if="user && access !== 'patient'">
                    <span class="feedback__header-text">Отзывы могут оставлять только пациенты!</span>
                </template>
                <template v-else>
                    <span class="feedback__header-text"><a href="/login">Авторизируйтесь</a>, чтобы оставить комментарий</span>
                </template>
            </template>
        </div>
        <div class="feedback__items">
            <form-review v-if="user && access === 'patient' && flag || isAnonym"></form-review>

            <answer v-for="review in reviews" v-if="reviews.length" :key="review.id" :review="review"></answer>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
    import {store} from "./review-store";

    import Answer from "./Answer";
    import FormReview from "./FormReview";

    export default {
        name: 'Review',
        store,
        components: {FormReview, Answer},
        props: {
            name: {
                type: String,
                required: true
            },
            useravatar: {
                type: String,
                required: true
            }
        },
        data: () => ({
            can: window.laravel.can,
            iconClasses: ['icon-circle-back', 'icon-circle-back', 'icon-circle-back'],
            isBad: true,
            isGood: true,
            badColor: "#CC5D5D",
            goodColor: "#2A7FAC",
            colors: ["#CC5D5D", "#CC5D5D", "#2A7FAC"],
            open: false,
            open_g: true,
            requiredRete: false,
            show: 0,
            has: 0,
            user: window.laravel.user,
            access: window.laravel.access,
            hasAppointment: window.laravel.hasAppointment,
            isAnonym: window.laravel.isAnonym,
            consultationId: null,
        }),
        mounted() {
            this.has = window.laravel.hasAppointment;
            this.consultationId = window.laravel.consultationId;

            this.setUserAvatar(this.useravatar);
        },
        computed: {
            ...mapState([
                'userAvatar',
                'reviews',
                'error',
                'flag',
            ]),
        },
        methods: {
            ...mapMutations([
                'setUserAvatar',
            ]),
            ...mapActions([
                'getResponse'
            ]),
        }
    }
</script>
<style>
    .text_right {
        text-align: right;
    }
</style>
